import { TMember } from "types/user.types";
import { EmptyLow, IndexContainer, RowContainer, TableContainer } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { deleteAlarmReceiver } from "apis/meeting-room-complain/alarm-receiver";
import { useToast } from "hook/useToast";

export interface IReceiverMember {
  id: string;
  mediumType: string;
  isActive?: boolean;
  host: TMember;
}

type PersonTableViewProps = {
  managers?: IReceiverMember[];
  onUpdate?: () => void;
};

const PersonTableView = ({ managers = [], onUpdate }: PersonTableViewProps) => {
  const { showToast } = useToast();

  const onDeleteComplainManager = async (memberId: string, name: string) => {
    const res = await deleteAlarmReceiver(memberId);
    if (res.success) {
      showToast(`민원 담당자 "${name}"이 삭제되었습니다.`, "success");
      onUpdate?.();
    } else {
      showToast("담당자 삭제에 실패했습니다. 재시도해 주세요.", "error");
    }
  };

  return (
    <TableContainer>
      <IndexContainer>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{
            minWidth: "160px",
            maxWidth: "200px",
            flex: 1,
          }}
        >
          이름
        </UI.Typography>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{
            flex: 1,
          }}
        >
          이메일
        </UI.Typography>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{
            minWidth: "74px",
            maxWidth: "160px",
            flex: 1,
          }}
        >
          관리
        </UI.Typography>
      </IndexContainer>
      {managers.length === 0 ? (
        <EmptyLow>
          <UI.Icon name="addPerson" color="var(--alias-color-label-alternative)" size={24} />
          <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
            등록된 담당자가 없습니다. 신속한 민원 처리를 위해 담당자를 추가해 주세요.
          </UI.Typography>
        </EmptyLow>
      ) : (
        managers.map((manager, index) => (
          <ManagerRow
            key={index}
            picture={manager.host.image}
            name={manager.host.nickname}
            email={manager.host.email}
            onDelete={() => {
              onDeleteComplainManager(manager.id, manager.host.nickname);
            }}
          />
        ))
      )}
    </TableContainer>
  );
};

export default PersonTableView;

const ManagerRow = ({
  picture,
  name,
  email,
  onDelete,
}: {
  picture?: string;
  name: string;
  email: string;
  onDelete?: () => void;
}) => {
  return (
    <RowContainer>
      <div className="user">
        {(!picture || picture === "") && <div className="empty-picture" />}
        {picture && picture !== "" && <img src={picture} />}
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          {name}
        </UI.Typography>
      </div>
      <div className="email">
        <UI.Typography
          type="label01"
          fontStyle="regular"
          color="var(--alias-color-label-alternative)"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {email}
        </UI.Typography>
      </div>
      <div
        style={{
          minWidth: "74px",
          flex: 1,
          maxWidth: "160px",
        }}
      >
        <UI.Button title="삭제하기" type="outlined" primary={false} size="small" onClick={onDelete} />
      </div>
    </RowContainer>
  );
};
